// @flow

export const defaultSorting = {
  field: 'name',
  dir: 'asc'
};
